<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="country">
                    <img :src="require(`./../../assets/image/${$store.state.record.country}.png`)" alt="">
                </div>
                <div class="main-area">
                    <div class="main-area-box">
                        <div class="order-item" :class="item.status===3?'sign':(item.status===2?'reject':'')"
                             v-for="(item,index) in list" :key="index">
                            <div class="title">
                                订单{{index+1}}·{{item.order.product.id === 1 ? '真丝头巾' : '羽绒服'}}
                            </div>
                            <div class="content">
                                <div class="img">
                                    <img src="./../../assets/image/signFor/MY.png" alt=""
                                         v-if="item.order.product.id===1">
                                    <img src="./../../assets/image/signFor/RUS.png" alt="" v-else>
                                </div>
                                <div class="txt">
                                    <span>
                                        订单数量：{{item.amount}}
                                    </span>
                                    <span>
                                        发货仓库：{{item.order.store.name}}·{{item.order.store.location}}
                                    </span>
                                    <span>
                                        所在国家：{{item.order.product.id===1?'马来西亚':'俄罗斯'}}
                                    </span>
                                </div>
                                <div class="handle-wrap" v-if="item.status ===1">
                                    <span @click="sign(item.id)">签收</span>
                                    <span @click="affirm=!affirm;shows[index]=true;rejectData.id=item.id">拒收</span>

                                    <div class="reject-affirm" v-show="shows[index]" :class="{affirm:affirm}">
                                        <div class="view-wrap">
                                            <div class="title">
                                                <strong>拒收订单</strong>
                                                REJECT ORDER
                                            </div>
                                            <div class="reason">
                                                <textarea placeholder="请输入拒收订单的原因" v-model="rejectData.note"></textarea>
                                            </div>
                                            <div class="store-wrap">
                                                <div class="store-wrap-title">
                                                    <strong>拒收订单</strong>
                                                    REJECT ORDER
                                                </div>
                                                <div class="store-wrap-content">
                                                    <div class="store-item" v-for="(itemm,indexx) in storeList"
                                                         :key="indexx"
                                                         v-if="(item.order.product.id == 1 && itemm.store.country === 'MY') || (item.order.product.id == 2 && itemm.store.country === 'RUS')"
                                                         @click="rejectData.storeId = itemm.id">
                                                        <div class="item-wrap"
                                                             :class="{active:rejectData.storeId===itemm.id}">
                                                            <div class="tit">
                                                                {{itemm.store.name}} • {{itemm.store.location}}
                                                            </div>
                                                            <div class="cont">
                                                                <img :src="itemm.store.image">
                                                            </div>
                                                            <div class="fo">
                                                                <i class="iconfont icon-xuanze-danxuan"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="foot">
                                                <span @click="reject(item)">确认</span>
                                                <span @click="affirm=!affirm;shows=[false,false,false]">取消</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot">
                <span class="btn" @click="$router.push('/finish-experiment/report')">
                    完成实验
                </span>
            </div>
        </div>
    </scroll-wrap>
</template>

<script>
    export default {
        name: "investigate",
        data() {
            return {
                list: [],
                shows:[false,false,false],
                storeList: [],
                affirm: false,
                rejectData: {
                    id: '',
                    note: '',
                    storeId: ''
                }
            }
        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                this.axios.post('/student/order/exp/list', {
                    experiment: {id: this.$store.state.record.experiment.id},
                    status: ''
                }).then(res => {
                    if (res.succeed && res.login) {
                        this.list = res.items
                        this.$store.commit('setState', {key: `record.order`, value: res.orderExp})
                    }
                })
                this.axios.post('/student/store/exp/list', {experiment: {id: this.$store.state.record.experiment.id}}).then(res => {
                    if (res.succeed && res.login) {
                        this.storeList = res.items
                    }
                })
            },
            sign(id) {
                this.axios.post('/student/order/exp/sign-for', {id: id}).then(res => {
                    if (res.succeed) {
                        this.$swal({
                            text: '订单成功签收',
                            icon: 'success',
                        })
                        this.getList()
                    } else {
                        this.$swal({
                            text: res.message,
                            icon: 'warning',
                        })
                    }
                })
            },
            reject(item) {
                this.axios.post('/student/order/exp/reject-for', {
                    id: item.id,
                    note: this.rejectData.note
                }).then(res => {
                    if (res.login && res.succeed) {
                        this.axios.post('/student/store/exp/in/apply/reject', {
                            experiment: {id: this.$store.state.record.experiment.id},
                            storeExp: {id: this.rejectData.storeId},
                            product: {id: item.order.product.id},
                            amount: item.amount
                        }).then(res => {
                            if (res.login && res.succeed) {
                                this.affirm = false;
                                this.shows = [false,false,false];
                                this.rejectData = {
                                    id: '',
                                    note: '',
                                    storeId: ''
                                }
                                this.getList()
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            position: relative;
            min-height: calc(100% - 88px);
            justify-content: flex-start;
            flex-grow: 1;

            .country {
                position: relative;
                width: 364px;
                min-width: 364px;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 20px;

                h6 {
                    width: 100%;
                    text-align: left;
                    padding-left: 60px;
                    line-height: 60px;
                    font-size: 16px;

                    i {
                        color: red;
                        margin-right: 3px;
                    }

                    e {
                        color: #004BFF;
                    }
                }

                .main-area-box {
                    display: flex;
                    justify-content: flex-start;
                    width: 100%;
                    flex-wrap: wrap;

                    div.order-item {
                        margin-right: 24px;
                        margin-bottom: 24px;
                        position: relative;

                        &.sign:before {
                            content: "签收";
                            position: absolute;
                            left: 50%;
                            bottom: 36px;
                            font-size: 24px;
                            font-weight: 900;
                            transform: translateX(-50%);
                            color: #009688;
                        }

                        &.reject:before {
                            content: "拒收";
                            position: absolute;
                            left: 50%;
                            bottom: 36px;
                            font-size: 24px;
                            font-weight: 900;
                            transform: translateX(-50%);
                            color: red;
                        }

                        > div.title {
                            width: 220px;
                            height: 44px;
                            line-height: 44px;
                            background: #517FFB;
                            border-radius: 10px;
                            color: #FFFFFF;
                            margin-bottom: 12px;
                        }

                        div.content {
                            width: 220px;
                            height: 424px;
                            background: #F1F5FD;
                            border-radius: 10px;
                            border: 12px solid #F1F5FD;
                            display: flex;
                            flex-direction: column;

                            > .img {
                                margin-bottom: 14px;
                            }

                            > .txt {
                                background: #FFFFFF;
                                border-radius: 10px;
                                display: flex;
                                flex-direction: column;
                                font-size: 14px;
                                padding: 0 16px;
                                align-items: flex-start;
                                margin-bottom: 20px;

                                > span {
                                    line-height: 32px;
                                }
                            }

                            .handle-wrap {
                                display: flex;
                                justify-content: space-between;
                                align-items: flex-end;
                                flex-grow: 1;
                                padding-bottom: 16px;

                                span {
                                    width: 84px;
                                    height: 32px;
                                    line-height: 32px;
                                    text-align: center;
                                    border-radius: 30px;
                                    background: #004bff;
                                    color: #FFFFFF;
                                    cursor: pointer;

                                    &:nth-child(2n) {
                                        background: #FF5300;
                                    }
                                }

                                div.reject-affirm {
                                    position: fixed;
                                    width: 100%;
                                    height: 100%;
                                    left: 0;
                                    top: 0;
                                    background: rgba(255, 255, 255, 0.6);
                                    z-index: 2;
                                    display: none;

                                    &.affirm {
                                        display: block;
                                    }

                                    > .view-wrap {
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);
                                        width: 628px;

                                        > .title {
                                            width: 100%;
                                            height: 44px;
                                            line-height: 44px;
                                            background: #004bff;
                                            border-radius: 10px;
                                            font-size: 10px;
                                            padding: 0 22px;
                                            text-align: left;
                                            margin-bottom: 12px;
                                            color: #FFFFFF;

                                            > strong {
                                                font-size: 18px;
                                                font-weight: bolder;
                                                margin-right: 6px;
                                            }
                                        }

                                        > .reason {
                                            width: 628px;
                                            height: 132px;
                                            margin-bottom: 12px;

                                            textarea {
                                                resize: none;
                                                width: 100%;
                                                height: 100%;
                                                border: 2px solid #004bff;
                                                border-radius: 10px;
                                                padding: 10px;
                                                font-size: 16px;
                                                outline: none;
                                                background: #F1F5FD;
                                            }
                                        }

                                        .store-wrap {
                                            width: 628px;
                                            height: 304px;
                                            padding: 22px;
                                            background: #004bff;
                                            border-radius: 10px;

                                            .store-wrap-title {
                                                width: 100%;
                                                background: #004bff;
                                                font-size: 10px;
                                                text-align: left;
                                                color: #FFFFFF;
                                                padding-bottom: 6px;
                                                border-bottom: 1px solid #FFFFFF;

                                                > strong {
                                                    font-size: 18px;
                                                    font-weight: bolder;
                                                    margin-right: 6px;
                                                }
                                            }

                                            .store-wrap-content {
                                                display: flex;

                                                .store-item {
                                                    width: 100%;

                                                    .item-wrap {
                                                        display: flex;
                                                        flex-direction: column;
                                                        align-items: center;
                                                        cursor: pointer;

                                                        &.active {
                                                            .fo > i {
                                                                color: #FBB521;
                                                            }
                                                        }

                                                        .tit {
                                                            color: #FFFFFF;
                                                            margin-top: 20px;
                                                            margin-bottom: 10px;
                                                        }

                                                        .cont {
                                                            width: 243px;
                                                            height: 133px;

                                                            > img {
                                                                width: 100%;
                                                                height: 100%;
                                                                object-fit: contain;
                                                            }
                                                        }

                                                        .fo {
                                                            margin-top: 10px;

                                                            i {
                                                                font-size: 20px;
                                                                color: #9e9e9e;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                        .foot {
                                            margin-top: 12px;

                                            span {
                                                padding: 10px 30px;
                                                margin-right: 20px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        > .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0 0 10px 10px;
            height: 88px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
